import { X } from "lucide-react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../shared/ui";
import { Notepad2 } from "iconsax-reactjs";

interface KybComplianceRequestSuccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
}

const KybComplianceRequestSuccessModal = ({
  open,
  onOpenChange,
  title = "Request created successfully",
  description = "The customer has been notified to submit the required information.",
}: KybComplianceRequestSuccessModalProps) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      overlayClassName="bg-black/75"
      contentClassName="max-w-[600px]  bg-white rounded-[24px]"
    >
      <ModalHeader className="justify-end px-4 pt-5">
        <button
          type="button"
          aria-label="Close modal"
          onClick={() => onOpenChange(false)}
          className="rounded-full p-2 text-[#161827] hover:bg-[#F2F4FF]"
        >
          <X size={20} />
        </button>
      </ModalHeader>
      <ModalBody className="flex flex-col items-center justify-center p-4 text-center">
        <div style={{
          background : 'linear-gradient(0deg, rgba(17, 168, 17, 0.3), rgba(17, 168, 17, 0.3)), linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 15%, rgba(29, 203, 28, 0.2) 26.5%, rgba(70, 227, 69, 0.2) 46%, rgba(255, 255, 255, 0.2) 55%, rgba(255, 255, 255, 0.14) 82.5%, rgba(255, 255, 255, 0) 100%)',
        }} className="flex h-16 w-16 items-center justify-center rounded-full  mb-2">
          <Notepad2 size={32} color={'#DCFDDB'} />
        </div>
        <h2 className="text-[24px] font-[600] text-[#161827]">
          {title}
        </h2>
        <p className="mt-3 text-[15px] font-[400] text-[#383B56]">
          {description}
        </p>
      </ModalBody>
        <ModalFooter className="border-t border-gray-60 w-full py-3">
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
          className="h-12 px-5s rounded-[14px] bg-[#161827] text-white hover:bg-[#2B2F49]"
          size='sm'
          >
            Done
          </Button>
        </ModalFooter>
    </Modal>
  );
};

export default KybComplianceRequestSuccessModal;
